import Populator from './populator.js';

export default class HashPopulator extends Populator {
    constructor(input) {
        super(input);
        this.bind(input);
        this.populate();
    }

    hashParams() {
        return new URLSearchParams(location.hash.split('?')[1] || '');
    }

    fromHash(key) {
        return this.hashParams().get(key);
    }

    bind() {
        window.addEventListener('hashchange', () => this.populate());
    }

    populate() {
        const key = this.input.el.dataset.hash;
        const value = this.fromHash(key);
        if (value) {
            super.populate(value);            
        }
    }

    static applies(input) {
        return input.el.dataset.hash !== undefined;
    }
}
